import { Environment } from './environment.model';

const packageJson = require('../../../../package.json');

export const environment: Environment = {
  production: true,
  name: 'stage',
  version: packageJson.version,
  hash: packageJson.hash,
  ngrxDevTools: [],
  translationHash: new Date().getTime().toString(),
  salesforce: 'https://jobcloud--test.sandbox.lightning.force.com/one/one.app',
  network: {
    jobs: 'https://stage.jobs.ch',
    jobcloud: 'https://www.stage.jobcloud.ch',
    js24: 'https://stage.jobscout24.ch',
    jobup: 'https://www.stage.jobup.ch',
  },
  api: {
    core: 'https://api.stage.jobcloud.ch',
    ats: 'https://ats.stage.jobcloud.ch',
    metadata: 'https://metadata-api-stage.jobcloud.services/api/v1/meta',
    media: 'https://media.stage.jobcloud.ch/media',
    ecom: 'https://ecommerce.stage.jobcloud.ch/api/v2/shop',
  },
  auth: {
    clientId: 'OatkxUAnfrQRGPh6qaIQj6leFYCzMsej',
    oldDomain: 'auth.stage.jobcloud.ai',
    domain: 'auth.stage.jobcloud.ch',
    audience: 'marketplace-apis',
    scope: 'openid profile email offline_access',
    connection: 'Username-Password-Authentication',
    oldRedirectUri: 'https://stage.jobcloud.ai',
    redirectUri: 'https://stage.one.jobcloud.ch',
    responseType: 'code',
    skipRedirectCallback: true,
    useRefreshTokens: true,
  },
  // TODO: remove when we no longer need these ids - CDP-1098
  createdByIdsForImportedJobAds: [
    '51fc2c5e-7a77-4cf6-aa03-b6a8758b3a50',
    '857ee77d-9836-4beb-9cec-5dab4c46a944',
    'ba73079d-c6f1-4bcd-986f-ef089df6cfe8',
  ],
};

export const auth = environment.auth;
export const createdByIdsForImportedJobAds = environment.createdByIdsForImportedJobAds;
